import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { STATUS } from './../../lib/helper'

class WPCOMTestimonial extends React.Component {
	render() {
		const { migrate } = this.props
		return <aside className="wpcom-migration-sidebar">
			<div className="wpcom-migration-sidebar__inner">
				<h3>What our customers are saying</h3>
				<p>
					&quot;After migrating to WordPress.com our site is faster, easier to use, more secure, and technical support is nearly instant.&quot;
					<br/>
					- Michael P.
				</p>

				<div className="wpcom-migration-testimonial">
					<div className="wpcom-migration-testimonial__text">Loved by our customers</div>
					<img className="wpcom-migration-testimonial__image" src="/assets/migration/wpcom-testimonial.png" alt="testimonial" />
				</div>
			</div>

			{ migrate.get('migration_complete') === STATUS.COMPLETED ? null : <p>Having trouble? <a href="https://wordpress.com/support/request-a-migration/" target="_blank" rel="noreferrer">
					Let us take over
			</a></p> }
		</aside>
	}
}

WPCOMTestimonial.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default WPCOMTestimonial
